.ux-iws-production-status {
    display: inline-block;

    .ux-iws-production-status__icon {
        font-size: 10px;
        margin-right: 10px;
        margin-bottom: 0;
        vertical-align: baseline;
    }

    .ux-iws-production-status__slot-container {
        display: inline-block;
    }

    .ux-iws-production-status__slot-container .ux-iws-production-status__icon {
        display: none;
    }
}
